import * as tslib_1 from "tslib"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

/**
 * @hidden
 */

var ResponseUtils =
/** @class */
function () {
  function ResponseUtils() {}

  ResponseUtils.setResponseIdToken = function (originalResponse, idTokenObj) {
    if (!originalResponse) {
      return null;
    } else if (!idTokenObj) {
      return originalResponse;
    }

    var exp = Number(idTokenObj.expiration);

    if (exp && !originalResponse.expiresOn) {
      originalResponse.expiresOn = new Date(exp * 1000);
    }

    return tslib_1.__assign({}, originalResponse, {
      idToken: idTokenObj,
      idTokenClaims: idTokenObj.claims,
      uniqueId: idTokenObj.objectId || idTokenObj.subject,
      tenantId: idTokenObj.tenantId
    });
  };

  return ResponseUtils;
}();

export { ResponseUtils };